/* eslint-disable */
<template>
  <div class="reward-page py-4 mt-4">
    <div class="container">
      <div class="card-container">
        <div class="w-full main-card px-3 md:px-4 lg:px-5 py-4 lg:py-5 xl:py-7">
          <Tabs size="large" v-model:activeKey="activeKey" class="w-full">
            <TabPane key="1" tab="Google maps API usage">
              <GoogleApi />
            </TabPane>
            <TabPane key="2" id="metricsTab" tab="Commute Stats">
              <PlatformStats />
            </TabPane>
            <TabPane key="3" tab="Trips Report">
              <TripsReport />
            </TabPane>
            <TabPane key="4" tab="Commuter Access Oddity">
              <CommuterAccessOddity />
            </TabPane>
          </Tabs>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/* eslint-disable */
import PlatformStats from '@/components/admin/PlatformStats/PlatformStats.vue';
import GoogleApi from '@/components/admin/PlatformStats/GoogleApi.vue';
import TripsReport from '@/components/admin/PlatformStats/TripsReport.vue';
import CommuterAccessOddity from '@/components/admin/PlatformStats/CommuterAccessOddity.vue';
import { Tabs, TabPane, Modal, Row, Col, Button } from 'ant-design-vue';
export default {
  components: {
    PlatformStats,
    GoogleApi,
    TripsReport,
    CommuterAccessOddity,
    Tabs,
    TabPane,
    Modal,
    Row,
    Button,
    Col,
  },
  data() {
    return {
      activeKey: '1',
      creditModal: true,
    };
  },
  computed: {
    query() {
      return this.$store.state.dash.dashStatsQuery;
    },
    data() {
      return this.$store.getters.dashStatsData;
    },
    user() {
      return this.$store.state.auth.user || null;
    },
    isAdmin() {
      return Boolean(localStorage.getItem('is_signas')) == true ? true : false;
    }
  },
};
</script>
<style scoped>

</style>
